<template>
  <v-row no-gutters>
    <v-col cols="6" class="pa-0 align-self-center">
      <span>{{ indicatorData["label"] }}</span>
    </v-col>
    <v-col v-if="indicatorData['input_ui'] === '1'" cols="6" class="pa-0">
      <div
          class="tip1Indicator"
          :style="{
          backgroundColor:
            Number(inputData).toFixed(1) === '1.0'
              ? `#${indicatorData['one_color']}`
              : `#${indicatorData['zero_color']}`,
          transition: 'background-color .4s ease-in-out'
        }"
      >
        <div class="indicatorOverlay"></div>
      </div>
    </v-col>
    <v-col v-else-if="indicatorData['input_ui'] === '4'" cols="6" class="pa-0">
      <v-chip class="body-1 font-weight-medium" label color="#3c5ccf"
              text-color="white"
      >{{ inputData }} {{ indicatorData["birim_text"] }}</v-chip
      >
    </v-col>
    <v-col v-else-if="indicatorData['input_ui'] === '5'" cols="6" class="pa-0">
      <v-chip class="body-1 font-weight-medium" label color="#3c5ccf"
              text-color="white"
      >{{ inputData['tr'] }}</v-chip
      >
    </v-col>
    <v-col v-else cols="6" class="pa-0">
      <v-chip class="body-1 font-weight-medium" label color="#3c5ccf"
              text-color="white"
      >{{ inputData }} {{ indicatorData["birim"] }}</v-chip
      >
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "inputValueIndicator",
  props: {
    /* Data as in 0 or 1
     * This prop is going to be the initial data that we receive from ListSetup
     * */
    inputData: {
      type: [String, Object],
      required: true
    },
    /*Contains object info*/
    indicatorData: {
      type: Object,
      required: true
    }
  }
};
</script>

<style scoped>
.tip1Indicator {
  height: 30px;
  width: 30px;
  border-radius: 4px;
  border: 2px solid black;
}

.indicatorOverlay {
  display: block;
  background: rgb(0, 0, 0);
  background: linear-gradient(
      180deg,
      rgba(0, 0, 0, 0.2) 0%,
      rgba(0, 0, 0, 0) 100%
  );
  margin: 0;
  padding: 0;
  height: 100%;
}
</style>
